import React from 'react';

import styles from './CarRentalCardSkeleton.module.css';

const CarRentalCardSkeleton: React.FC = () => (
  <div className={styles.wrapper} data-testid='car-rental-card-skeleton'>
    <div className={styles.col}>
      <div className={styles.header} />
      <div className={styles.body} />
    </div>
    <div className={styles.colRight}>
      <div className={styles.price} />
    </div>
  </div>
);

export default CarRentalCardSkeleton;
